// extracted by mini-css-extract-plugin
export default {"charity-manage-account-form":"styles__charity-manage-account-form____1o3W","readOnly":"styles__readOnly___ZnglI"};